import { GeoJson } from '@ais-ui/api-spec/shapes';

const FEATURE_TYPES = new Set(['Feature', 'FeatureCollection']);

/**
 * Normalizes a GeoJSON value that might be a raw Geometry (e.g. { type: "Polygon", coordinates: [...] })
 * into a proper Feature structure that our rendering pipeline expects.
 *
 * Some APIs (S2S, Grounding) return geometry as a raw GeoJSON Geometry object
 * rather than a Feature wrapper. This function ensures a consistent Feature shape.
 */
export const normalizeToFeature = (geom: GeoJson): GeoJson => {
  if (FEATURE_TYPES.has(geom.type)) {
    return geom;
  }

  return {
    type: 'Feature',
    properties: {},
    geometry: geom,
  } as unknown as GeoJson;
};
